module.exports = __webpack_public_path__ + "assets/03378cf48590396ad99c9e5b89a5f54f.candidates_active_arrow.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/candidates_active_arrow.svg
 ** module id = 829
 ** module chunks = 1
 **/